(function() {
	'use strict';

	/*
	 * @ngdoc object @name payment @description
	 * 
	 */
	angular.module('paymentRates', [ 'ui.router' ]);
}());
